import { useMemo } from "react";
import type { Copy } from "@b2bportal/air-exchange-api";
import type { ChangeFlightContactAirlineScenario } from "@b2bportal/core-flights";
import type { IChangeFlightEligibilityClasses } from "@b2bportal/core-types";
import type { IChangeFlightEligibilityData } from "@tenant/flights";
import { Button, ButtonTypeEnum } from "@tenant/ui";
import DOMPurify from "dompurify";

export interface IChangeFlightEligibilityContactAirlineProps {
  classes?: Partial<
    IChangeFlightEligibilityClasses & {
      visitAirlineBtn: string;
    }
  >;
  copy: IChangeFlightEligibilityData["copy"];
  policy: ChangeFlightContactAirlineScenario;
  policyCopy?: Copy;
}

export const ChangeFlightEligibilityContactAirline = (
  props: IChangeFlightEligibilityContactAirlineProps
) => {
  const { classes, copy, policy, policyCopy } = props;

  const ContactAirlineButtons = useMemo(() => {
    const { airlines } = policy;

    return airlines.map((airline) => {
      const { changeCancelPolicy, homePage, manageBooking } = airline.webLinks;
      const airlineWebsite = changeCancelPolicy ?? manageBooking ?? homePage;

      return (
        <Button
          buttonType={ButtonTypeEnum.Primary}
          className={classes?.visitAirlineBtn}
          key={airline.name}
          onClick={() => window.open(airlineWebsite, "_target")?.focus()}
        >
          {copy.visitAirlineBtn(airline.name)}
        </Button>
      );
    });
  }, [classes, copy, policy]);

  return (
    <div className={classes?.modalContent}>
      {policyCopy != null && (
        <div className={classes?.contentHeader}>
          <span
            className={classes?.contentTitle}
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(policyCopy.title),
            }}
          />
          {policyCopy.body.map((item) => (
            <span
              key={item}
              className={classes?.contentBody}
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item) }}
            />
          ))}
        </div>
      )}
      <div className={classes?.contentActions}>{ContactAirlineButtons}</div>
    </div>
  );
};
